<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('User.AdultCertification.msg1') }}</div>
        <div class="ft-point">{{ $t('User.AdultCertification.msg6') }}</div>
        <div class="lyr-txt">{{ $t('User.AdultCertification.msg7') }}</div>
      </div>
      <div class="layer__body">
        <img src="@/assets/images/user/artwork_popup_members_3d.gif" alt="" class="img-size" />
      </div>
      <div class="layer__button">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('closeAdultCert')">{{ $t('Modal.Barcode.msg4') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'adultCert',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {
  },
  props: {
    adultType: Number, //1 : kakao, 2 : pass
  },
  methods: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
